import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle,} from "@mui/material";
import Grid from "@mui/material/Grid";
import CustomMultiText from "../../../widgets/inputs/CustomMultiText";
import Button from "@mui/material/Button";
import StoricoTicket from "./StoricoTicket";
import {useForm} from "react-hook-form";
import {bigNoteRegisterRequired} from "../../../../utils/RegisterUtils";
import { Skeleton } from '@mui/material';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {updateTicket} from "../../../../services/TicketServices";
import {sollecitaTicketApi} from "../../../../services/utils/ApiData";
import {TicketContext} from "../../../../App";
import clsx from "clsx";
import {useHistory} from "react-router-dom";
import axios from "axios";
import {BASE_NAME} from "../../../../services/utils/ApiUrls";
import {getConfig} from "../../../../services/utils/ConfigUtils";
import {getAccountInfo} from "../../../../utils/GenericUtils";

const SollecitaTicket = ({open, onClose, ticket, isDiary = false, canModify = true, canRestore = false}) => {
	const classes = BaseStyle();
	const ticketContext = useContext(TicketContext);
	const {register, errors, handleSubmit, reset, getValues} = useForm({mode: "onChange"})
	let history = useHistory();
	const [ripristina, setRipristina] = useState(false);
	
	const onSubmit = useCallback((data) => {
		updateTicket({
			...ticket,
			ticketId: ticket.id,
			...sollecitaTicketApi({...ticket, ...data}),
		}, ticketContext.dispatch);
	}, [ticket, ticketContext.dispatch])
	
	const handleKeyDown = useCallback((event) => {
		if (event.ctrlKey && event.keyCode === 13) {
			updateTicket({
				...ticket,
				ticketId: ticket.id,
				...sollecitaTicketApi({...ticket, ...getValues()}),
			}, ticketContext.dispatch);
		}
	}, [ticket, ticketContext.dispatch, getValues])
	
	const ripristinaTicket = () => {
		setRipristina(true);
		console.log(ticket);
		axios
			.post(BASE_NAME + "ticket/restore", {id: ticket}, getConfig())
			.then(() => {
				setRipristina(false);
				alert("Ticket ripristinato con successo!");
				window.location.reload();
			})
			.catch((error) => {
				setRipristina(false);
				alert(JSON.stringify(error))
			})
	}
	
	useEffect(() => {
		if (!ticketContext.state.loadingAddHistory && ticketContext.state.errorAddHistory === "") {
			reset();
		}
	}, [ticketContext.state.loadingAddHistory, ticketContext.state.errorAddHistory, reset])
	
	useEffect(() => {
		if (!ticketContext.state.loadingGetHistory && ticketContext.state.errorGetHistory === "") {
			let id = ticketContext.state.ticketHistory.length;
			document.getElementById("paper-storico" + (id - 1))?.scrollIntoView();
		}
	}, [ticketContext.state.loadingGetHistory, ticketContext.state.errorGetHistory, ticketContext.state.ticketHistory])
	
	return (
		<React.Fragment>
			<Dialog open={open} maxWidth={"lg"} onClose={() => onClose(false)} fullWidth={true} className={classes.zIndex9000}
			        PaperProps={{classes: {root: clsx(classes.roundBorder, classes.zIndex9000)}}}>
				<DialogTitle>
					<b>Ticket n° {ticket.id ? ticket.id : ticket}</b>
				</DialogTitle>
				<DialogContent>
					<form onSubmit={handleSubmit(onSubmit)} id={"sollecito-form"}>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								{
									ticketContext.state.loadingGetHistory ?
										<Skeleton animation={"pulse"} className={classes.roundBorder} height={300}/> :
										ticketContext.state.errorGetHistory !== "" ? ticketContext.state.errorGetHistory :
											<StoricoTicket storicoTicket={ticketContext.state.ticketHistory}/>
								}
							</Grid>
							{canModify && <Grid item xs={12}>
								<CustomMultiText
									inputRef={register(bigNoteRegisterRequired)}
									name={"note"}
									label={"Note *"}
									placeholder={"Aggiungi delle note allo storico per poter sollecitare o per aggiungere informazioni al ticket"}
									autoFocus={true}
									error={errors["note"]}
									rows={5}
									handleKeyDown={handleKeyDown}
								/>
							</Grid>}
						</Grid>
					</form>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => onClose(false)} size={"small"}
					        style={{borderRadius: 24}}
					        className={classes.roundButton}>
						<b>Chiudi</b>
					</Button>
					{
						canRestore && <Button onClick={ripristinaTicket} size="small"
						                      disableElevation
						                      style={{borderRadius: 24}}
						                      disabled={ripristina}
						                      variant={"contained"} color={"primary"}
						                      className={classes.roundButton}>
							<b>Ripristina ticket</b>
						</Button>
					}
					{!isDiary && canModify &&
						<Button onClick={() => history.push("/gestione/callcenter/" + ticket.idSoggetto)} size={"small"}
						        style={{borderRadius: 24}}
						        className={classes.roundButton}>
							<b>Importa dati</b>
						</Button>}
					{canModify && <Button onClick={handleSubmit(onSubmit)} size="small"
					                      disableElevation
					                      disabled={getAccountInfo().roles?.includes("ROLE_SP_301_H")}
					                      style={{borderRadius: 24}}
					                      variant={"contained"} color={"primary"}
					                      className={classes.roundButton}>
						<b>Aggiungi modifiche</b>
					</Button>}
				</DialogActions>
			</Dialog>
		</React.Fragment>
	);
};

export default React.memo(SollecitaTicket);
